import { baseUrl, GetHeaders, handleResponse, handleError, PutOptions, PostOptions, DeleteHeaders } from "../common/ApiUtils";

const apiUrl = baseUrl + "FrequentlyAskedQuestions/";

export function getFAQs() {
  return fetch(apiUrl, GetHeaders()).then(handleResponse).catch(handleError);
}

export function addFAQ(question) {
  return fetch(apiUrl, PostOptions(question)).then(handleResponse).catch(handleError);
}

export function updateQuestion(questionId, question) {
  return fetch(apiUrl + questionId, PutOptions(question))
    .then(handleResponse)
    .catch(handleError);
}

export function updateUsefulnessScore(questionId, change) {
  if (change < 0) {
    return fetch(apiUrl + "decrement/" + questionId, PutOptions())
      .then(handleResponse)
      .catch(handleError);
  } else {
    return fetch(apiUrl + "increment/" + questionId, PutOptions())
      .then(handleResponse)
      .catch(handleError);
  }
}

export function removeFAQ(questionId) {
  return fetch(apiUrl + "delete/" + questionId, DeleteHeaders())
    .then(handleResponse)
    .catch(handleError);
}
